let exchangeRatesCache = null;

export const getCurrencySymbol = (currencyCode = 'USD') => {
  if (!currencyCode) return '$';
  try {
    return (0).toLocaleString(undefined, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).replace(/\d/g, '').trim();
  } catch (e) {
    console.error("Invalid currency code:", currencyCode);
    return '$';
  }
};
  
export const formatCurrency = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return "0.00";
  return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const fetchExchangeRates = async () => {
  if (exchangeRatesCache) return exchangeRatesCache;
  try {
    const response = await fetch('/fiat_list.txt');
    if (!response.ok) throw new Error('Failed to fetch rates');
    const data = await response.json();
    exchangeRatesCache = data;
    return data;
  } catch (e) {
    console.error('Error fetching exchange rates:', e);
    return {};
  }
};

export const getRate = async (currencyCode) => {
  if (!currencyCode) return 1;
  const rates = await fetchExchangeRates();
  const code = currencyCode.toUpperCase();
  const rate = rates[code];
  if (rate === undefined) {
    console.error("Currency code not found:", currencyCode);
    return 1;
  }
  return rate;
};